import { render, staticRenderFns } from "./management.cattle.io.feature.vue?vue&type=template&id=02083880&scoped=true&"
import script from "./management.cattle.io.feature.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.feature.vue?vue&type=script&lang=js&"
import style0 from "./management.cattle.io.feature.vue?vue&type=style&index=0&id=02083880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02083880",
  null
  
)

export default component.exports